import Vue from 'vue'
import util from '@/util'
import imageStreamUtil from '@/components/layout/imageStream/js/util'
import TooltipAniversario from '@/components/layout/tooltipAniversarios/TooltipAniversarios.vue'
import usuarioUtil from './usuarioUtil'

const customizacaoLayoutEvento = ($event, document, vm) => {
  if ($event.event.extendedProps.ehEventoAniversario) {
    customizarToolTipAniversario($event, vm)
    atribuirClasseAniversario($event)
    adicionarIconeAniversario($event, document)
  } else {
    customizarToolTipEvento($event)
  }
}

const customizarToolTipEvento = ($event) => {
  let conteudoPopOver = obterNomeEHorario($event)
  util.abrirPopOver($event.el, {
    content: conteudoPopOver,
    container: 'body',
    placement: 'top',
    boundary: 'window',
    html: true,
    offset: 1
  })
}

const obterNomeEHorario = ($event) => {
  return '<div>' + $event.timeText + ' ' + $event.event.title + '</div>'
}

const customizarToolTipAniversario = async ($event, vm) => {
  let nome = $event.event.extendedProps.nome
  let email = $event.event.extendedProps.email
  let idCliente = $event.event.extendedProps.idCliente
  let image64 = $event.event.extendedProps.image64
  let foto = null
  let tipo = $event.event.extendedProps.tipo
  if (tipo === 'usuario') {
    foto = usuarioUtil.usuarioTemFoto($event.event.extendedProps.foto)
      ? imageStreamUtil.obterEnderecoImagem($event.event.extendedProps.foto)
      : require('@/assets/img/usuario-sem-foto.png')
  } else {
    foto = image64 !== null ? image64 : require('@/assets/img/usuario-sem-foto.png')
  }

  // Cria um elemento Vue para o tooltip
  const TooltipClass = Vue.extend(TooltipAniversario)
  const tooltipInstance = new TooltipClass({
    propsData: { foto, nome, email, idCliente, permitido: $event.event.extendedProps.permitido, tipo: $event.event.extendedProps.tipo, abaCliente: $event.event.extendedProps.abaCliente, image64: $event.event.extendedProps.image64 }
  })

  tooltipInstance.$on('acessar-cliente', (idCliente) => {
    if (vm && typeof vm.acessarCliente === 'function') {
      vm.acessarCliente(idCliente)
    }
  })

  tooltipInstance.$mount()
  util.abrirPopOver($event.el, {
    content: tooltipInstance.$el,
    container: 'body',
    placement: 'top',
    boundary: 'window',
    html: true,
    offset: 1
  })
}

const atribuirClasseAniversario = ($event) => {
  $event.el.getElementsByClassName('fc-event-main-frame')[0].classList.add('fc-event-aniversario', 'fc-event-aniversario-hover')
  $event.el.getElementsByClassName('fc-event-title fc-sticky')[0].classList.add('fc-event-aniversario-hover')
}

const adicionarIconeAniversario = ($event, document) => {
  let icone = document.createElement('i')
  icone.setAttribute('class', 'fas fa-birthday-cake')
  $event.el.getElementsByClassName('fc-event-title-container')[0].prepend(icone)
}

export default {
  customizacaoLayoutEvento
}
